<template>
	<div>
		<v-dialog
			:value="showModal"
			:width="width"
		>
			<v-card>
				<v-card-text>
					{{ text }}
				</v-card-text>
				<v-card-actions class="justify-center">
					<v-btn
						class="btn-action caption"
						color="primary"
						:disabled="loading"
						@click="$emit('cancel')"
					>
						{{ cancelText }}
					</v-btn>
					<v-btn
						class="btn-action caption"
						color="error"
						:disabled="loading"
						@click="$emit('confirm')"
					>
						{{ confirmationText }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: 'app-confirmation-modal',
	props: {
		cancelText: {
			type: String,
			default: 'Cancelar',
		},
		confirmationText: {
			type: String,
			default: 'Eliminar',
		},
		loading: {
			default: false,
			type: Boolean,
		},
		showModal: {
			type: Boolean,
			default: false,
		},
		text: {
			type: String,
			default: 'Está seguro que desea eliminar este registro?',
		},
		width: {
			type: Number,
			default: 500,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/app-confirmation-modal.vue